import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IAlertOptionsType {
    message: string
    isYesNoAlert: boolean
    yesCallback: () => void
    noCallback: () => void
    yesText?: string
    noText?: string
    okayText?: string
    target?: any
}

export interface IAlertState {
    alertOptions: IAlertOptionsType,
    alertOpen: boolean,
    MIOpen: boolean,
    idlePromptOpen: boolean,
}

const initialAlertOptions = {
    message: '',
    isYesNoAlert: false,
    yesCallback: () => { return },
    noCallback: () => { return },
}

const initialState: IAlertState = {
    alertOptions: initialAlertOptions,
    alertOpen: false,
    MIOpen: false,
    idlePromptOpen: false,
}

export const alertSlice = createSlice({
    name: 'alertSlice',
    initialState,
    reducers: {
        setAlert: (state, action: PayloadAction<IAlertOptionsType>) => {
            state.alertOptions = action.payload
            state.alertOpen = !!action.payload.message
        },
        resetAlert: (state) => {
            state.alertOptions = initialAlertOptions
            state.alertOpen = false
        },
        setMI: (state) => {
            state.MIOpen = true
        },
        resetMI: (state) => {
            state.MIOpen = false
        },
        setIdlePrompt: (state) => {
            state.idlePromptOpen = true
        },
        resetIdlePrompt: (state) => {
            state.idlePromptOpen = false
        },
    },
})

export const {
    setAlert,
    resetAlert,
    setMI,
    resetMI,
    setIdlePrompt,
    resetIdlePrompt,
} = alertSlice.actions

export default alertSlice.reducer
